import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { EdtellHeaderService } from "@edtell-common";
import { first } from "rxjs/operators";
import { CourseOverviewDetail } from "src/app/modules/catalog/interfaces/course-overview-detail.interface";
import { ShoppingCartService } from "../../services/shopping-cart.service";

@Component({
  selector: "app-enrollment-header",
  templateUrl: "./enrollment-header.component.html",
  styleUrls: ["./enrollment-header.component.scss"],
})
export class EnrollmentHeaderComponent implements OnInit {
  showShoppingCart = false;

  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private edtellHeaderService: EdtellHeaderService,
  ) {}

  ngOnInit() {
    this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd) {
        await this.refreshHeaderData();
      }
    });
    this.refreshHeaderData();
  }

  async refreshHeaderData() {
    const landingParam = this.edtellHeaderService.getRouteQueryParams().landing;
    const schoolCode = this.edtellHeaderService.getRouteParams().schoolId;
    const validSchoolCode = await this.shoppingCartService
      .validateSchoolCodeAndProgramId(schoolCode)
      .pipe(first())
      .toPromise();

    this.showShoppingCart =
      this.edtellHeaderService.getRouteData().showShoppingCart &&
      landingParam != "true" &&
      validSchoolCode;
  }

  get shoppingCart() {
    return this.shoppingCartService.currShoppingCart;
  }

  async openShoppingCart() {
    const errorResponse = await this.shoppingCartService
      .checkRegistrationError()
      .pipe(first())
      .toPromise();
    if (errorResponse == "cancel") {
      return;
    }
    if (errorResponse == "new registration") {
      this.shoppingCartService.clearShoppingCart();
    }
    this.shoppingCartService.openReviewCoursesDialog().subscribe(() => {});
  }
}
